import { AfterViewInit, Directive, ElementRef, EventEmitter, Host, Output, Renderer2, Self } from '@angular/core';
import { AutoComplete } from 'primeng/autocomplete';
import { TranslateService } from '@ngx-translate/core';

@Directive({
  selector: '[avanoSelectFieldMultiple]'
})
export class SelectFieldMultipleDirective implements AfterViewInit {
  @Output() readonly selectButtonClick: EventEmitter<void> = new EventEmitter();

  constructor(@Host() @Self() public host: AutoComplete, public el: ElementRef, public renderer: Renderer2, private translateService: TranslateService) {}

  /** Creates the wrapper element, adds the button and sets the styles aswell as the mouselistener. */
  ngAfterViewInit(): void {
    this.setAutocompleteDefaults();

    const containerElement = this.createWrapperElement();

    // Insert the container before the autocomplete element
    this.el.nativeElement.parentElement.insertBefore(containerElement, this.el.nativeElement);

    // Put the autocomplete element and button inside the container.
    containerElement.appendChild(this.el.nativeElement);
    containerElement.appendChild(this.createButtonElement());
  }

  private setAutocompleteDefaults(): void {
    // Set autocomplete defaults for "avano select field multiple"-behavior
    this.host.dropdown = false;
    this.host.multiple = true;
    this.host.showEmptyMessage = true;
    this.host.emptyMessage = this.getEmptyMessage();

    this.host.forceSelection = true;
    this.host.suggestions = [];

    this.host.completeMethod.subscribe(() => {
      // We act like we would have changed the suggestions-array on the autocomplete
      // This will lead to the empty message of the autocomplete,
      // there we tell the user that he should not enter text, but use the dialog
      this.host.handleSuggestionsChange();
      this.host.cd.markForCheck(); // Otherwise only after second character the overlay is displayed?
    });
  }

  private createButtonElement(): HTMLElement {
    const buttonElement = this.renderer.createElement('div');
    this.renderer.addClass(buttonElement, 'avano-selectfield-button');

    if (this.host.disabled) {
      this.renderer.addClass(buttonElement, 'disabled');
    }

    const anchorIconElement = this.renderer.createElement('i');
    this.renderer.addClass(anchorIconElement, 'icon-content-select-data');
    buttonElement.appendChild(anchorIconElement);
    buttonElement.addEventListener('click', () => this.selectButtonClick.emit());

    return buttonElement;
  }

  private createWrapperElement(): HTMLElement {
    const containerElement = this.renderer.createElement('div');
    this.renderer.addClass(containerElement, 'avano-selectfield-wrapper');
    return containerElement;
  }

  private getEmptyMessage(): string {
    const emptyMessagekey = 'avano.component.autocomplete.emptymessage.forceDialogSelection';
    const emptyMessageFallback = 'Please open the dialog for selection'; // Needed for extraction to common lib
    const emptyMessage = this.translateService.instant(emptyMessagekey);
    return emptyMessage !== emptyMessagekey ? emptyMessage : emptyMessageFallback;
  }
}
